/** Cookie utility functions */
export function getCookie(name: string): string {
  const prefix = name + '='
  const cookies = document.cookie.split(';')
  for (const c of cookies) {
    const trimmed = c.trim()
    if (trimmed.indexOf(prefix) === 0) {
      return trimmed.substring(prefix.length)
    }
  }
  return ''
}

export function setCookie(name: string, value: string, days: number): void {
  const d = new Date()
  d.setTime(d.getTime() + days * 86400000)
  document.cookie = `${name}=${value}; path=/; expires=${d.toUTCString()}`
}
